export default "__VITE_ASSET__f4f2c787__"